import { Grid, Typography, Box , Table, TableBody, TableCell, TableContainer, TableRow, Paper } from "@mui/material"
import styles from './index.module.css'
import { useEffect, useState } from "react";

const data = [
    { qty: 5, dollar: 100 },
    { qty: 10, dollar: 200 },
    { qty: 15, dollar: 300 }
  ];
const Content = ({title, description, type,priceData}) => {
    return(
        <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            {type === 'Text'?<TextContent description={description} />: <PriceContent data={priceData}/>}
          </Grid>
    )
}

const TextContent = ({description}) => {
    return (
        <Typography variant="body1" paragraph color={'grey'}>
        {description}
      </Typography>
    )
}

const PriceContent = ({data}) => {
    const [tableAlign, setTableAlign] = useState('center')
    useEffect(()=>{
        if(data?.length < 2){
            setTableAlign('right')
        }else{
            setTableAlign('center')
        }
    },[data])
    return (
        <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableBody className={styles.border}>
            <TableRow>
              <TableCell className={styles.noBorder}>
               <Typography className={styles.boldText}>QTY</Typography> 
            </TableCell>
              {/* First Row: qty values */}
              {data?.map((item, index) => (
                <TableCell key={`qty-${index}`} className={styles.noBorder}
                 align={tableAlign}>{item.Quantity}</TableCell>
              ))}
            </TableRow>
            <TableRow>
            <TableCell className={styles.tableBorder}>
            <Typography className={styles.boldText}>$</Typography>
            </TableCell>
              {/* Second Row: dollar values */}
              {data?.map((item, index) => (
                <TableCell key={`dollar-${index}`} className={styles.tableBorder} align={tableAlign}>{item.Price}</TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    )
}



export default Content